import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pt-5 d-none d-md-block"
}
const _hoisted_2 = { class: "title-3 text-grey-900 pb-2" }
const _hoisted_3 = { class: "d-flex list-unstyled list-group-horizontal justify-content-between pt-4" }
const _hoisted_4 = {
  key: 0,
  class: "caption text-grey-900 pe-2"
}
const _hoisted_5 = { class: "d-inline-block tf-btn--circle-1 border-primary-green caption-strong text-primary-green" }
const _hoisted_6 = { class: "body text-grey-900 ps-2" }
const _hoisted_7 = {
  key: 1,
  class: "caption text-grey-900 pe-2"
}
const _hoisted_8 = { class: "d-inline-block tf-btn--circle-1 border-primary-blue caption-strong text-primary-blue" }
const _hoisted_9 = { class: "body text-grey-900 ps-2" }
const _hoisted_10 = {
  key: 2,
  class: "caption text-grey-900 pe-2"
}
const _hoisted_11 = {
  class: "d-inline-block tf-btn--circle-1 border-primary-red caption-strong",
  style: {"color":"#b91515"}
}
const _hoisted_12 = { class: "body text-grey-900 ps-2" }
const _hoisted_13 = {
  key: 3,
  class: "caption text-grey-900 pe-2"
}
const _hoisted_14 = { class: "d-inline-block tf-btn--circle-1 border-black text-primary-black caption-strong" }
const _hoisted_15 = { class: "body text-grey-900 ps-2" }

interface SlopesInformationProps {
  nbSlopesGreen: number;
  nbSlopesBlue: number;
  nbSlopesRed: number;
  nbSlopesBlack: number;
  domainName: string;
  content: Record<string, string>;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SlopesInformation',
  props: {
    nbSlopesGreen: {},
    nbSlopesBlue: {},
    nbSlopesRed: {},
    nbSlopesBlack: {},
    domainName: {},
    content: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_ctx.nbSlopesGreen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.content.station_Slopes) + " " + _toDisplayString(_ctx.domainName), 1),
        _createElementVNode("ul", _hoisted_3, [
          (_ctx.nbSlopesGreen > 0)
            ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.nbSlopesGreen), 1),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.content.station_GreenSlopes), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.nbSlopesBlue > 0)
            ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.nbSlopesBlue), 1),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.content.station_BlueSlopes), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.nbSlopesRed > 0)
            ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.nbSlopesRed), 1),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.content.station_RedSlopes), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.nbSlopesBlack > 0)
            ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.nbSlopesBlack), 1),
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.content.station_BlackSlopes), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})